<template>
  <div class="women-reactivation-page">
    <LandingPageBody v-bind="landingPageProps" />
  </div>
</template>

<script>
import LandingPageBody from '@/components/CampaignLandingPage/LandingPageBody'
import { LandingPageType } from '@/enums/landing'
import { AUTH_ID } from '@/utils/store/getterTypes'
import { mapState, mapGetters } from 'vuex'
import { NewOrientations } from '@/enums/products'

export default {
  name: 'ReactivationLandingPage',
  layout: 'homepage-signup-button',
  components: {
    LandingPageBody
  },
  computed: {
    landingPageProps () {
      return {
        locizePath: 'LandingPage.WomenReactivation',
        imagePath: '/images/frontend/reactivation/women/',
        appCountry: this.country,
        locale: this.locale,
        userIdentifier: this.userId,
        landingpageUrl: '/women/reactivate',
        primaryColor: this.$t('LandingPage.WomenReactivation.HexColor'),
        type: LandingPageType.reactivate,
        orientation: NewOrientations.women
      }
    },
    ...mapState('app', {
      country: state => state.country,
      locale: state => state.locale
    }),
    ...mapGetters('auth', {
      userId: AUTH_ID
    })
  }
}
</script>

<style scoped lang="postcss">
.women-reactivation-page {
  >>> {
    .landingpage-hero-title,
    .landingpage-hero-description {
      @apply text-gray-600;
    }
  }
}
</style>
